import moment from 'moment';

export function formatDate(dateString) {
  return moment(dateString, 'YYYY-MM-DD hh:mm:ss A').format('lll');
}
